import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  AppTableComponent,
  ModalWindowComponent,
  SearchModel,
  SearchResultModel,
  RequestItemsLegalTermListModel,
  RequestItemsLegalTermListService,
  Auth,
  MessagesComponent,
  ViewState,
  DocumentsService,
  DocumentFileDownloadModel,
  Form,
  FormElement,
  DocumentFileSaveModel
} from 'src/common';
import { TranslationManager } from 'src/common/translation';
import { Router } from '@angular/router';
import { ElementViewModel } from "../../components";
import { DocumentComponentName } from "../../../common/enums/documentComponentName";


@Component({
  selector: 'app-request-items-legal-term-list-ssy1220list',
  templateUrl: './request-items-legal-term-list-ssy1220list.component.html'
})
export class RequestItemsLegalTermListSsy1220listComponent {
  deleteDocument: boolean = false;
  // custom-constructor-start

  fileToUpload: File = null;
  MaxFileSize: number = 1048576 * 10; // do 10 MB

  _requestId: number;

  private _state: ViewState;
  viewState = ViewState;

  selectedItem: any;

  displayEditDlg = false;
  deleteDocumentShow:boolean=false;
  private _supplierOfferId: number;

  constructor(private router: Router, private requestItemsLegalTermListViewService: RequestItemsLegalTermListService,
    private documentService: DocumentsService) {
  }

  // custom-constructor-end

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("modalWindow") modalWindow: ModalWindowComponent;
  translationManager = TranslationManager;
  items: RequestItemsLegalTermListModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;
  auth = Auth;
  customHeaderText = '';
  form: Form;

  documentToUpload: DocumentFileSaveModel;
  documentComponentName = DocumentComponentName.SupplierOfferLegalTerms;

  @Input()
  set supplierOfferId(value: number) {
    this._supplierOfferId = value;

    this.requestItemsLegalTermListViewService.getLegalTerms(this.supplierOfferId ?? 0).then((result: RequestItemsLegalTermListModel[]) => {
       this.items = result;
    });
  }
  get supplierOfferId(): number {
    return this._supplierOfferId;
  }

  @Input()
  set state(value: ViewState) {
    this._state = value;
  }
  get state(): ViewState {
    return this._state;
  }

  @Input()
  set requestId(value: number) {
    this._requestId = value;
  }
  get requestId(): number {
    return this._requestId;
  }





  create() {
    this.routerNavigateToCreate();
  }

  openDetails(id: number) {
    this.router.navigate(['/requestItemsLegalTermLists/details/' + id]);
  }

  delete() {
    this.showDeleteModal = false;
    this.requestItemsLegalTermListViewService.delete(this.idForDelete).then(() => {
      this.requestItemsLegalTermListViewService.getAll().then((items: RequestItemsLegalTermListModel[]) => {
        this.items = items;
      });
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
    });
  }

  showDeleteModalFor(id: number) {
    this.idForDelete = id;
    this.showDeleteModal = true;
  }

  // custom-start
  private routerNavigateToCreate() {
    this.router.navigate(['request-items-legal-term-list/create']);
  }

  save() {
    let isDocumentMandatory = this.selectedItem['isDocumentMandatory'];

 

    delete this.selectedItem['requestId'];
    delete this.selectedItem['supplierOfferId'];
    delete this.selectedItem['conditionName'];
    //delete this.selectedItem['isDocumentMandatory'];
    delete this.selectedItem['supplierOfferLegalTermsElementUsedId'];

    this.selectedItem['documentContent'] = this.form.elements['documentContent'].value;
    this.selectedItem['documentName'] = this.form.elements['documentName'].value;
    this.selectedItem['documentId'] = this.form.elements['documentId'].value;

    if (this.deleteDocument) {
      this.removeFile();
    }


    this.selectedItem['value'] = this.form.elements["value"].value ? 1 : 0;

    if (isDocumentMandatory && !(this.selectedItem['documentContent'] || this.selectedItem['documentId'])) {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('SuplierOfferLegalTerms_RequiredDocument')]);
      return;
    }
   

    this.requestItemsLegalTermListViewService.saveOfferLegalTerms(this.toUpperKeys(this.selectedItem)).then(() => {
      this.displayEditDlg = false;

      this.requestItemsLegalTermListViewService.getLegalTerms(this.supplierOfferId ?? 0).then((result: RequestItemsLegalTermListModel[]) => {
        this.items = result;
      });

      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);

    }).catch((reason: any) => {
      if (reason !== null) {
        if (reason.status === 400) {
          if (reason.error !== null) {
            const mescustom = reason.error.messages;
            MessagesComponent.instance.showError([mescustom]);
          }
        } else {
          MessagesComponent.instance.showError(reason.error.messages);
        }
      }
    });
  }

  removeFile() {
    this.selectedItem['documentContent'] = undefined;
    this.selectedItem['documentName'] = undefined;
    this.selectedItem['documentId'] = undefined;
  }

  handleFileInput(files: FileList): void {
    this.fileToUpload = files.item(0);

    if (this.fileToUpload) {
      if (this.fileToUpload.size > this.MaxFileSize) {
        MessagesComponent.instance.showError([this.translationManager.getTranslation('Величина датотеке треба да буде мања од 10 МБ')]);
        return;
      }

      const reader = new FileReader();
      reader.readAsArrayBuffer(this.fileToUpload);
      reader.onload = () => {
        const base64 = reader.result as ArrayBuffer;
        const attachment = new Uint8Array(base64);
        this.form.elements['documentContent'].value = this.arrayBufferToBase64String(attachment); //attachment;
        this.form.elements['documentName'].value = this.fileToUpload.name;
        this.form.elements['documentId'].value = undefined;
        // this.saveFileToDatabase();
      };
    } else {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Фајл не постоји')]);
    }
  }

  arrayBufferToBase64String(buffer: ArrayBuffer): string {
    let binaryString = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
      binaryString += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binaryString);
  }

  downloadFile(id: number, fileName: string): void {
    this.documentService.downloadDocument(id, this.documentComponentName).then((data: DocumentFileDownloadModel) => {
      if (data) {
        this.download(data.content, data.name);
      } else {
        MessagesComponent.instance.showError([this.translationManager.getTranslation("Документ није пронађен")]);
      }
    }).catch((reason: any) => {
      if (reason !== null) {
        if (reason.status === 400) {
          if (reason.error !== null) {
            if (reason.error.message) {
              const mescustom = reason.error.message;
              MessagesComponent.instance.showError([mescustom]);
            }
          }
        } else {
          MessagesComponent.instance.showError(reason.error.messages);
        }
      }
    });
  }

  downloadFile1(item: any) {
    if (this.form.elements['documentContent'].value) {
      this.download(this.form.elements['documentContent'].value, this.form.elements['documentName'].value);
    }
  }

  private download(base64String, fileName): void {
    const source = `data:application/octet-stream;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.target = '_blank';
    link.click();
  }

  downloadFileFromServer(id: number, fileName: string): void {
    this.documentService.downloadDocument(id, this.documentComponentName).then((data: DocumentFileDownloadModel) => {
      this.download(data.content, data.name);
    });
  }

  edit(r) {
    this.selectedItem = Object.assign({}, r);

    this.form = new Form();
    this.form.elements["value"] = new FormElement();

    this.form.elements['documentContent'] = new FormElement();
    this.form.elements['documentName'] = new FormElement();

    this.form.elements['documentId'] = new FormElement();
    this.form.elements["value"].value = this.selectedItem['value'];
    this.form.elements['documentContent'].value = this.selectedItem['documentContent'];
    this.form.elements['documentName'].value = this.selectedItem['documentName'];
    this.form.elements['documentId'].value = this.selectedItem['documentId'];

    this.deleteDocumentShow=(!this.selectedItem['isDocumentMandatory'] && this.selectedItem['documentName']!=null);

    this.displayEditDlg = true;

    if(!this.deleteDocumentShow){
      this.deleteDocument = false;
    }
    
  }

  saveFileToDatabase() {
    if (this.documentToUpload.content === null || this.documentToUpload.content == undefined) {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Фајл не постоји')]);
      return;
    }
    this.documentService.saveDocument(this.documentToUpload).then(() => {
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Успешно сачуван ентитет')]);
    });
  }

  toUpperKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[(key[0].toUpperCase() + key.substring(1, key.length))] = obj[key];
      return accumulator;
    }, {});
  }

  // custom-end
}

